import { type SanityProductFragment } from '@data/sanity/queries/types/product'

import ProductCard from '@blocks/shop/product-card'

interface FeaturedProductsProps {
  products: SanityProductFragment[]
  onClick?: () => void
}

const FeaturedProducts = ({ products, onClick }: FeaturedProductsProps) => {
  if (products.length === 0) {
    return null
  }

  return (
    <>
      {products.map((product) => (
        <ProductCard
          key={product.productID}
          product={product}
          onClick={onClick}
        />
      ))}
    </>
  )
}

export default FeaturedProducts
